import script from "./Identity.vue?vue&type=script&setup=true&lang=js"
export * from "./Identity.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__